export default __webpack_public_path__ + "static/media/img5.c408b2ad.PNG";